import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { Button, IconButton } from '@material-ui/core';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faBars } from "@fortawesome/free-solid-svg-icons";
import { getUserName } from "../utils/auth";
import { Link } from "react-router-dom";
import { getOfficeId } from '../utils/preferences';

const styles = theme => ({
  root: {
    display: 'flex'
  },
  title: {
    // This makes the user name to align right
    flexGrow: 1
  },
  button: {
    margin: theme.spacing(1),
    textTransform: "none"
  },
  rightIcon: {
    marginLeft: theme.spacing(1),
  },
});

function withAppBar(WrappedComponent) {
  class TireHotelAppBar extends Component {
    render() {
      const { classes } = this.props;
      const userName = getUserName();
      const officeId = getOfficeId();
      return (
        <>
          <AppBar position="sticky" color="primary">
            <Toolbar>
              <Typography variant="h6" color="inherit" className={classes.title}>
                { userName &&
                  <Link to="/">                    
                    <IconButton color="secondary" className={classes.button}>
                      <FontAwesomeIcon icon={faBars}/>
                    </IconButton>
                  </Link>
                }
              </Typography>
              { userName &&
                <Link to="/user">
                  <Button variant="contained" color="secondary" className={classes.button}>
                    {userName}{officeId && ' (' + officeId + ')'}
                    <FontAwesomeIcon icon={faUser} className={classes.rightIcon}/>
                  </Button>
                </Link>
              }
            </Toolbar>
          </AppBar>        
          <div style={{ width: "100%", flex: "1 0 auto", display: "flex", flexDirection: "column", paddingLeft: 16, paddingRight: 16 }}>
            <WrappedComponent {...this.props} />
          </div>
        </>
      );
    }
  };

  // @ts-ignore
  return withStyles(styles)(TireHotelAppBar);
}

export default withAppBar;